export default __webpack_public_path__ + "static/soehne-web-fett-6cb1fe428c7b6ecef59dcbc47635074b.woff2";